import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseModal = _resolveComponent("BaseModal")!

  return (_openBlock(), _createBlock(_component_BaseModal, {
    "is-display": _ctx.isDisplay,
    title: _ctx.title,
    size: _ctx.size,
    width: _ctx.width,
    "close-on-backdrop-click": _ctx.closeOnBackdropClick,
    onClose: _ctx.onCloseIconClickedHandler
  }, {
    footer: _withCtx(() => [
      _renderSlot(_ctx.$slots, "dialog-footer")
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "dialog-content")
    ]),
    _: 3
  }, 8, ["is-display", "title", "size", "width", "close-on-backdrop-click", "onClose"]))
}